import { useLayoutEffect } from 'react';

export const APP_TITLE = 'Vector India Student Portal';

/**
 * Sets the browser tab title for the current page.
 * @param {string|null|undefined} pageTitle - Short page name; omit for app title only.
 */
export function usePageTitle(pageTitle) {
    useLayoutEffect(() => {
        document.title = pageTitle ? `${pageTitle} | ${APP_TITLE}` : APP_TITLE;
        return () => {
            document.title = APP_TITLE;
        };
    }, [pageTitle]);
}
